// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"6bfb5e0c","787":"d1542201","921":"1f1d9943"}[chunkId] + ".chunk.js";
};